import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  isOpen: false,
  storeKey: null,
  modalProps: {},
  triggerElement: null, // Store ID for focus restoration
  loading: false,
  error: null,
};

const offerModalSlice = createSlice({
  name: "offerModal",
  initialState,
  reducers: {
    openModal: (state, action) => {
      const { storeKey, props = {}, triggerElement = null } = action.payload;
      state.isOpen = true;
      state.storeKey = storeKey;
      state.modalProps = props;
      state.triggerElement = triggerElement;
      state.error = null;
      state.loading = false;
    },

    closeModal: (state) => {
      state.isOpen = false;
      state.storeKey = null;
      state.modalProps = {};
      state.loading = false;
      state.error = null;
      // Keep triggerElement briefly for focus restoration
      // Will be cleared by the hook after focus is restored
    },

    clearTriggerElement: (state) => {
      state.triggerElement = null;
    },

    updateModalProps: (state, action) => {
      state.modalProps = { ...state.modalProps, ...action.payload };
    },

    setModalLoading: (state, action) => {
      state.loading = action.payload;
    },

    setModalError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },

    resetModal: () => initialState,
  },
});

export const actions = offerModalSlice.actions;

export default offerModalSlice.reducer;
